'use client'

import Link from "next/link"
import { useState } from "react"
import { Button } from "../shadcn/button"
import DonationPopin from "../account/DonationPopin"

export default function DonationButton() {

    const [popinOpened, setPopinOpened] = useState(false)
    
	return (
		<>
            <Link
                href="#"
                onClick={() => setPopinOpened(true)}
                className="text-black font-semibold text-sm hidden lg:block"
            >
                <Button variant="optional">
                    Faire un don
                </Button>
            </Link>
            <DonationPopin isOpen={popinOpened} closeAction={() => setPopinOpened(false)} />
        </>
	)
}